import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useGetManagerGroupQuery } from '../../api/groupApi';
import { useGetGroupDeliveryDetailsQuery } from '../../api/metricsApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import { CHANNEL_LABELS } from '../../utils/channels';
import { rangeFromSearchParams } from '../../utils/dateRange';
import useDeliveryRows from '../../hooks/useDeliveryRows';
import BackHeader from '../../components/BackHeader/BackHeader';
import DeliveriesTable from '../../components/DeliveriesTable/DeliveriesTable';
import s from '../../styles/shared/page.module.css';
import table from '../../styles/shared/table.module.css';

export default function MetricsChannelDeliveriesPage() {
  const { id: groupId } = useParams();
  const [searchParams] = useSearchParams();
  const showToast = useToast();

  const channel = searchParams.get('channel') ?? 'email';
  const range = rangeFromSearchParams(searchParams);
  const channelLabel = CHANNEL_LABELS[channel] ?? channel;

  const { data: group } = useGetManagerGroupQuery(groupId);
  const {
    data: deliveryDetails,
    isLoading,
    isError,
    error,
  } = useGetGroupDeliveryDetailsQuery({ groupId, channel, range });

  useEffect(() => {
    if (isError) showToast('error', 'Deliveries', errMsg(error, 'Could not load delivery details.'));
  }, [isError, error, showToast]);

  const { allRows, rows, statusFilter, setStatusFilter } = useDeliveryRows(deliveryDetails?.deliveries);

  return (
    <div className={s.page}>
      <BackHeader
        to="/manager/metrics"
        label="Back to Metrics"
        title={`${channelLabel} details${group ? ` — ${group.name}` : ''}`}
      />

      <DeliveriesTable
        rows={rows}
        isEmpty={allRows.length === 0}
        isLoading={isLoading}
        emptyLabel="deliveries"
        statusFilter={statusFilter}
        onStatusFilterChange={setStatusFilter}
        firstColumnHeader="Subscriber"
        firstColumnClassName={table.contactCol}
        firstColumnBody={(d) => <div className={table.cellInsider}>{d.subscriber_email || 'Unknown'}</div>}
      />
    </div>
  );
}
